import { useEffect, useRef, useState } from 'react';
import { Button } from 'primereact/button';
import { Checkbox } from 'primereact/checkbox';
import buttons from '../../styles/shared/buttons.module.css';
import styles from './TermsGate.module.css';

export default function TermsGate({ terms, onAgree, isSubmitting }) {
  const scrollRef = useRef(null);
  const [reachedBottom, setReachedBottom] = useState(false);
  const [acknowledged, setAcknowledged] = useState(false);

  function handleScroll(e) {
    const el = e.currentTarget;
    if (el.scrollHeight - el.scrollTop - el.clientHeight < 4) {
      setReachedBottom(true);
    }
  }

  useEffect(() => {
    const el = scrollRef.current;
    if (el && el.scrollHeight <= el.clientHeight) {
      setReachedBottom(true);
    }
  }, [terms]);

  return (
    <div>
      <div
        ref={scrollRef}
        onScroll={handleScroll}
        className={styles.scrollBox}
        dangerouslySetInnerHTML={{ __html: terms || 'No terms provided.' }}
      />
      <div className={`${styles.acknowledgeRow} ${!reachedBottom ? styles.acknowledgeRowDisabled : ''}`}>
        <Checkbox
          inputId="termsAcknowledge"
          checked={acknowledged}
          disabled={!reachedBottom}
          onChange={(e) => setAcknowledged(e.checked)}
        />
        <label
          htmlFor="termsAcknowledge"
          className={`${styles.acknowledgeLabel} ${!reachedBottom ? styles.acknowledgeLabelDisabled : ''}`}
        >
          I have read and agree to the terms
        </label>
      </div>
      <div className={!acknowledged || isSubmitting ? styles.buttonWrapperDisabled : undefined}>
        <Button
          type="button"
          onClick={onAgree}
          disabled={!acknowledged || isSubmitting}
          loading={isSubmitting}
          label={reachedBottom ? 'Subscribe' : 'Scroll to the bottom to continue'}
          className={`${buttons.accentBtn} ${styles.agreeButton}`}
        />
      </div>
    </div>
  );
}
